import * as React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { assets } from '../../../assets';
import {FormattedMessage} from "react-intl";

const Wrapper = styled.header`
  height: 56px;
  width: 56px;
  border: 2px solid #ffffff;
  border-radius: 2px;
  background: #161616;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: none;
`;

const BackIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin-bottom: 2px;
`;

const HeaderBackButton = (props: { url?: string; onClick?: () => void }): JSX.Element => {
  const history = useHistory();

  const handleOnClick = (): void => {
    if (props.url) {
      history.push(props.url);
    } else if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <Wrapper onClick={handleOnClick}>
      <BackIcon src={assets.icons.back_arrow} />
      <div className="text-12">
        <b>
          <FormattedMessage id="common.backButton" />
        </b>
      </div>
    </Wrapper>
  );
};

export default HeaderBackButton;
